"use client"
import { createContext } from "react"
import type { createDropStore } from "@/components/collection/drops/drop-store"

export type DropStoreApi = ReturnType<typeof createDropStore>

export const CollectionDropContext = createContext<DropStoreApi | null>(null)
